
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cbd-store/[slug]/write-review",
      function () {
        return require("private-next-pages/cbd-store/[slug]/write-review.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cbd-store/[slug]/write-review"])
      });
    }
  